import A from 'utils/metrics/analytic'

// Будущие - нажал на кнопку "Хочу смотреть"/отписался от вебинара
enum originSubscribe {
  OWN = 'own',
  EMAIL = 'email',
  WEBINAR_FUTURE = 'webinar_future',
  WEBINAR_FUTURE_LIST = 'webinar_future_list',
  WEBINAR_PAST = 'webinar_past',
  WEBINAR_LIVE = 'webinar_live',
  ARTICLE = 'article',
  PODCAST = 'podcast',
  NOORIGIN = 'origin',
}

const A_wf_clickSubscription = (origin: originSubscribe, id: number) => {
  A.setEvent('webinar_click_subscription', { origin, id: String(id) })
}

// Открытие страницы будущего вебинара

enum originFWebinar {
  EMAIL = 'email',
  WEBINAR_FUTURE = 'webinar_future',
  WEBINAR_FUTURE_LIST = 'webinar_future_list',
  WEBINAR_PAST = 'webinar_past',
  WEBINAR_LIVE = 'webinar_live',
  WEBINAR_WANTSEE = 'webinar_wantsee',
  FEED = 'feed',
  FEED_BANNER = 'feed_banner',
  LANDING = 'landing',
  ARTICLE = 'article',
  PODCAST = 'podcast',
  NOORIGIN = 'noorigin',
}

const A_wf_openWebinar = (origin: originFWebinar, id: number) => {
  if (origin === originFWebinar.NOORIGIN) {
    A.setEvent('webinar_future_open', { id: String(id) })
  } else {
    A.setEvent('webinar_future_open', { origin, id: String(id) })
  }
}

export { A_wf_clickSubscription, A_wf_openWebinar, originSubscribe, originFWebinar }
